const MESES = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

export function formatGuardiaFecha(fecha: string): { day: string; time: string } {
  const d = new Date(fecha);
  if (isNaN(d.getTime())) return { day: fecha, time: "" };
  const day = `${d.getDate()}-${MESES[d.getMonth()]}`;
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return { day, time: `${hh}:${mm}hs` };
}
